import { useState } from 'react';

export default function Portfolio() {
  const [activeFilter, setActiveFilter] = useState('all');

  const filters = ['all', 'websites', 'mobile', 'animation', 'branding'];

  const projects = [
    {
      title: 'E-Commerce Platform',
      category: 'websites',
      description: 'Modern Shopify store with custom features and 300% conversion increase',
      image: 'https://public.readdy.ai/ai/img_res/596bd50c7ec942894a4fe9a32d5b2438.jpg',
      tags: ['Shopify', 'React', 'Custom Development']
    },
    {
      title: 'Fitness Mobile App',
      category: 'mobile',
      description: 'Cross-platform fitness tracking app with 50K+ active users',
      image: 'https://readdy.ai/api/search-image?query=Sleek%20fitness%20mobile%20application%20interface%20on%20smartphone%20mockup%20showing%20workout%20tracking%20screens%2C%20health%20metrics%2C%20blue%20gradient%20design%2C%20modern%20fitness%20app%20UI%2C%20bright%20studio%20lighting%2C%20white%20background%2C%20professional%20presentation&width=800&height=600&seq=portfolio-fitness-002&orientation=landscape',
      tags: ['React Native', 'iOS', 'Android']
    },
    {
      title: 'Product Launch Video',
      category: 'animation',
      description: '4K animated explainer video that generated 2M+ views',
      image: 'https://readdy.ai/api/search-image?query=Professional%204K%20video%20production%20setup%20with%20colorful%20motion%20graphics%20elements%2C%20abstract%203D%20shapes%2C%20vibrant%20animation%20frames%2C%20modern%20video%20editing%20workspace%2C%20bright%20studio%20lighting%2C%20white%20background%2C%20cinematic%20quality&width=800&height=600&seq=portfolio-video-003&orientation=landscape',
      tags: ['3D Animation', '4K Video', 'Motion Graphics']
    },
    {
      title: 'SaaS Dashboard',
      category: 'websites',
      description: 'Enterprise analytics platform with real-time data visualization',
      image: 'https://readdy.ai/api/search-image?query=Modern%20SaaS%20dashboard%20interface%20on%20desktop%20monitor%20showing%20data%20analytics%20charts%2C%20graphs%2C%20metrics%2C%20purple%20and%20blue%20color%20scheme%2C%20clean%20professional%20design%2C%20bright%20studio%20lighting%2C%20white%20background%2C%20business%20intelligence%20visualization&width=800&height=600&seq=portfolio-saas-004&orientation=landscape',
      tags: ['React', 'Node.js', 'AWS']
    },
    {
      title: 'Restaurant App',
      category: 'mobile',
      description: 'Food delivery app with seamless ordering and tracking',
      image: 'https://readdy.ai/api/search-image?query=Beautiful%20restaurant%20food%20delivery%20mobile%20app%20interface%20on%20smartphone%20showing%20menu%20items%2C%20order%20tracking%2C%20orange%20and%20red%20accent%20colors%2C%20modern%20food%20app%20design%2C%20bright%20studio%20lighting%2C%20white%20background%2C%20appetizing%20presentation&width=800&height=600&seq=portfolio-restaurant-005&orientation=landscape',
      tags: ['Flutter', 'Firebase', 'Maps API']
    },
    {
      title: 'Brand Identity',
      category: 'branding',
      description: 'Complete brand redesign including logo, guidelines, and assets',
      image: 'https://readdy.ai/api/search-image?query=Professional%20brand%20identity%20design%20showcase%20with%20logo%20variations%2C%20color%20palette%2C%20typography%20samples%2C%20business%20cards%2C%20modern%20branding%20materials%2C%20purple%20and%20blue%20colors%2C%20bright%20studio%20lighting%2C%20white%20background%2C%20clean%20presentation&width=800&height=600&seq=portfolio-brand-006&orientation=landscape',
      tags: ['Branding', 'Logo Design', 'Guidelines']
    },
    {
      title: 'Corporate Website',
      category: 'websites',
      description: 'Professional corporate site with CMS and multilingual support',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20corporate%20business%20website%20interface%20on%20desktop%20showing%20professional%20layout%2C%20team%20sections%2C%20services%20pages%2C%20blue%20and%20gray%20color%20scheme%2C%20modern%20business%20web%20design%2C%20bright%20studio%20lighting%2C%20white%20background%2C%20executive%20presentation&width=800&height=600&seq=portfolio-corporate-007&orientation=landscape',
      tags: ['WordPress', 'Custom Theme', 'SEO']
    },
    {
      title: '3D Product Visualization',
      category: 'animation',
      description: 'Photorealistic 3D renders for product marketing campaigns',
      image: 'https://readdy.ai/api/search-image?query=Stunning%203D%20product%20visualization%20render%20showing%20detailed%20product%20model%20with%20realistic%20lighting%2C%20reflections%2C%20shadows%2C%20professional%203D%20modeling%20showcase%2C%20bright%20studio%20lighting%2C%20white%20background%2C%20photorealistic%20quality&width=800&height=600&seq=portfolio-3d-008&orientation=landscape',
      tags: ['Blender', '3D Modeling', 'Rendering']
    },
    {
      title: 'Social Media Platform',
      category: 'mobile',
      description: 'Community-focused social app with 100K+ downloads',
      image: 'https://readdy.ai/api/search-image?query=Modern%20social%20media%20mobile%20application%20interface%20on%20smartphone%20showing%20user%20profiles%2C%20feed%2C%20messaging%20features%2C%20colorful%20gradient%20design%2C%20engaging%20social%20app%20UI%2C%20bright%20studio%20lighting%2C%20white%20background%2C%20vibrant%20presentation&width=800&height=600&seq=portfolio-social-009&orientation=landscape',
      tags: ['React Native', 'GraphQL', 'Real-time']
    }
  ];

  const filteredProjects = activeFilter === 'all' 
    ? projects 
    : projects.filter(p => p.category === activeFilter);

  return (
    <section id="portfolio" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-purple-600 font-semibold text-sm uppercase tracking-wider">Portfolio</span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mt-4 mb-6">
            Our Latest Work
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Explore our diverse portfolio of successful projects across web, mobile, animation, and branding.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {filters.map((filter) => (
            <button
              key={filter}
              onClick={() => setActiveFilter(filter)}
              className={`px-6 py-3 rounded-full font-medium transition-all cursor-pointer whitespace-nowrap ${
                activeFilter === filter
                  ? 'bg-gradient-to-r from-purple-600 to-blue-600 text-white shadow-lg'
                  : 'bg-white text-gray-700 border border-gray-200 hover:border-purple-300'
              }`}
            >
              {filter.charAt(0).toUpperCase() + filter.slice(1)}
            </button>
          ))}
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProjects.map((project, index) => (
            <div 
              key={index}
              className="group bg-white rounded-3xl overflow-hidden border border-gray-100 hover:shadow-2xl transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-64 overflow-hidden">
                <img 
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
              </div>
              
              <div className="p-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-2 group-hover:text-purple-600 transition-colors">
                  {project.title}
                </h3>
                
                <p className="text-gray-600 mb-4">
                  {project.description}
                </p>
                
                <div className="flex flex-wrap gap-2">
                  {project.tags.map((tag, idx) => (
                    <span 
                      key={idx}
                      className="px-3 py-1 bg-purple-50 text-purple-600 rounded-full text-xs font-medium"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button className="bg-gradient-to-r from-purple-600 to-blue-600 text-white px-8 py-4 rounded-full font-semibold hover:shadow-lg transition-all cursor-pointer whitespace-nowrap group">
            View All Projects
            <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform inline-block"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
